export const device = {
  accessorySetting: "配件设置",
  AISettings: "AI设置",
  alertDirection: "警示方向",
  alertLanguage: "警示语言",
  alerts: "警示",
  alertVolume: "警示音量",
  allAlerts: "全部警示",
  audio: "声音",
  bothDirections: "前后方",
  chineseSimplified: "简体中文",
  chineseTraditional: "中文（繁体）",
  criticalAlertsOnly: "仅危险区警示",
  criticalAlertType: "危险区警示音类型",
  defaultDisplayLayout: "默认显示界面",
  displayLayout: "显示界面",
  displayLayoutWithReverseLightSensor: "带倒车灯传感器的显示界面",
  displayLayoutWithSpeedSensor: "带速度传感器的显示界面",
  driverLogin: "司机登录",
  driverSafetySystem: "驾驶安全系统",
  english: "英文",
  FaceID: "面部识别",
  fatigueAlerts: "疲劳驾驶警示",
  fiveGHz: "5G",
  french: "法语",
  frontAlerts: "前方警示",
  frontAndRearDynamic: "动态切换前后方画面",
  german: "德语",
  imperial: "英制",
  italian: "意大利语",
  japanese: "日语",
  leftAlerts: "左方警示",
  loginMethod: "登录方式",
  loginPictureDelay: "登录拍照延迟（秒）",
  loginScanTime: "登录扫描时长（秒）",
  loginPictureDelayNoUnit: "登录拍照延迟",
  loginScanTimeNoUnit: "登录扫描时长",
  maximumSpeedLimit: "限速",
  maximumSpeedLimitWithUnit: "限速 ({0})",
  metric: "公制",
  movingDirectionOnly: "仅移动方向警示",
  NFCCard: "NFC卡",
  no: "否",
  noAlerts: "不警示",
  output1: "输出一",
  output2: "输出二",
  outputAllDSSAlerts: "所有驾驶行为警示",
  outputAllFrontPDAlerts: "“前方”人员侦测提示",
  outputAllGeofencingAlerts: "所有电子围栏警示",
  outputAllLeftPDAlerts: "“左方”人员侦测提示",
  outputAllPDAlerts: "所有方向人员侦测警示",
  outputAllPDCriticalAlerts: "所有方向危险区人员侦测警示",
  outputAllPDWarningAlerts: "所有方向警示区行人侦测警示",
  outputAllRearPDAlerts: "“后方”人员侦测提示",
  outputAllRightPDAlerts: "“右方”人员侦测提示",
  outputAuthorizedDriverAlert: "合法驾驶提示",
  outputBlockedCameraAlert: "仅摄像头遮挡警示",
  outputCustomization: "输出客制化",
  outputEnterGeofenceZoneAlert: "进入电子围栏警示",
  outputExitGeofenceZoneAlert: "离开电子围栏警示",
  outputFailedCriticalItemInspectionReportAlert: "点检不合格警示",
  outputFatigueAlert: "仅疲劳警示",
  outputFrontPDCriticalAlerts: "仅“前方”危险区人员侦测警示",
  outputFrontPDWarningAlerts: "仅“前方”警示区行人侦测警示",
  outputGPONone: "未指定",
  outputLeftPDCriticalAlerts: "仅“左方”危险区人员侦测警示",
  outputLeftPDWarningAlerts: "仅“左方”警示区行人侦测警示",
  outputNoSeatBeltAlert: "未系安全带警示",
  outputOverSpeedAlert: "超速警示",
  outputPhoneUsageAlert: "仅使用手机警示",
  outputRearPDCriticalAlerts: "仅“后方”危险区人员侦测警示",
  outputRearPDWarningAlerts: "仅“后方”警示区行人侦测警示",
  outputRightPDCriticalAlerts: "仅“右方”危险区人员侦测警示",
  outputRightPDWarningAlerts: "仅“右方”警示区行人侦测警示",
  outputSmokingAlert: "仅抽烟警示",
  outputUnauthorizedDriverAlert: "不合法驾驶警示",
  outputVoltage: "输出电平",
  outputVoltagePullHigh: "高",
  outputVoltagePullLow: "低",
  peopleDetection: "人员侦测",
  phoneAlerts: "使用手机警示",
  qRCode: "二维码",
  rearAlerts: "后方警示",
  rearDynamic: "动态切换后方画面",
  rearOnly: "只显示后方画面",
  rightAlerts: "右方警示",
  showDetectionBoxes: "显示侦测框",
  smokingAlerts: "抽烟警示",
  sound: "音频",
  spanish: "西班牙语",
  speedIndicatorUnits: "速度单位",
  allCamera: "显示全部画面",
  twoCamera: "左右并排显示",
  twoPointFourGHz: "2.4G",
  USCustomary: "美制",
  voice: "人声",
  warningAlertType: "警示区警示音类型",
  wiFi: "Wi-Fi",
  wiFiMode: "Wi-Fi模式",
  yes: "是",
  pictureUpload: "图片上传",
  videoUpload: "视频上传",
  alertAudio: "警示音",
  geofenceAlerts: "电子围栏警示",
  speedingAlerts: "超速警示",
  seatbeltAlerts: "未系安全带警示",
  hardhatOffAlerts: "未戴安全帽警示",
  ExtendAICamera: "驾驶摄像头C100",
  cameraBlocked: "摄像头遮挡警示",
  cameraShiftAlerts: "摄像头偏移警示",
  leaveSeatAlerts: "离开座位警示",
  geofencing: "电子围栏",
  CriticalAlerts: "危险区警示",
  speedSensorLowBatteryAlerts: "速度传感器低电量警示",
  seatBeltSensorLowBatteryAlerts: "安全带传感器低电量警示",
  driverChangedAlerts: "司机换人警示",
  frontRightAlerts: "右前方警示",
  rearRightAlerts: "右后方警示",
  cam1Alerts: "人员侦测-摄像头1",
  cam2Alerts: "人员侦测-摄像头2",
  collisionIconAlerts: "防撞图标警示",
  safetyDetection: "安全措施侦测",
  hardhatDetection: "安全帽侦测",
  mcw: "计米轮",
  mcwShortName: "计米轮",
  mcwExemptedSetting: "计米轮豁免设置",
  safetyHeightOfHook: "吊钩安全高度",
  ExemptedLocalAlertSound: "豁免本地告警音",
  ExemptedUploadToCloud: "豁免上传云端",
  ExemptedGPOOutput: "豁免GPO输出",
  GPISetting: "GPI 设置",
  GPI: "GPI",
  triggerLevel: "触发电平",
  highLevel: "高电平",
  lowLevel: "低电平",
  GPO: "GPO",
  GPO1: "GPO1",
  GPO2: "GPO2",
  GPO3: "GPO3",
  GPO4: "GPO4",
  extendGPO1: "扩展GPO1",
  extendGPO2: "扩展GPO2",
  extendGPO3: "扩展GPO3",
  extendGPO4: "扩展GPO4",
  extendGPO: "扩展GPO",
  GPOSetting: "GPO 设置",
  ExtendGPOSetting: "扩展GPO 设置",
  ExemptionSignal: "豁免信号",
  VehicleMovingSignal: "大小车移动信号",
  StopLargeVehicle: "大车停车",
  StopSmallVehicle: "小车停车",
  StopLiftingHook: "吊钩停车",
  LiftingHookLowSpeed: "吊钩低速",
  StartProjection: "投影启动",
  TriggerPeriod: "电平控制时长",
  TriggerPeriodTips: "（取值范围 3000 - 15000毫秒）",
  millisecond: "毫秒",
  PDTriggerCondition: "PD报警触发范围",
  ProjectOnlyWhenMoving: "大小车移动时进行投影",
  ExemptedAlertUploadVideo: "危险区授权作业视频上传",
  ExemptedAlertUploadImage: "危险区授权作业图片上传",
  poseAuthorization: "姿态授权申请",
  CriticalAlertUploadVideo: "危险区视频上传",
  CriticalAlertUploadImage: "危险区图片上传",
};
